import { AsyncAction } from 'actions/actions.types'
import { fetchPaymentTypeListApi } from 'api/billing/billingApi'

export const FETCH_PAYMENT_TYPE_LIST = 'FETCH_PAYMENT_TYPE_LIST'

export interface FetchPaymentTypeListAction extends AsyncAction {
  type: typeof FETCH_PAYMENT_TYPE_LIST
}

export const fetchPaymentTypeListAction = (orderId: string) => ({
  type: FETCH_PAYMENT_TYPE_LIST,
  promise: () => fetchPaymentTypeListApi(orderId),
})
